<template>
  <v-container fluid>
    <v-row v-show="!viewAnnouncement">
      <v-col cols="12">
        <v-card>
          <v-toolbar
            flat
            color="white"
          >
            <v-col cols="4">
              <v-text-field
                v-model="search"
                label="Search Announcement"
                append-icon="search"
                placeholder="Search by keyword (Title, Date/Year, Announced By)"
                hide-details
              />
            </v-col>
            <v-col 
              cols="3"
              class="mt-5"
            >
              <v-autocomplete
                v-model="announcementCategoryFilter"
                clearable
                :items="announcementCategories"
                label="Announcement Category Filter"
                placeholder="Choose announcement category"
                item-text="name"
                item-value="id"
                value="id"
              />
            </v-col>
            <v-spacer /><v-spacer /><v-spacer /><v-spacer />  
          </v-toolbar>

          <v-data-table
            :search="search" 
            :headers="headers"
            :items="filterAnnouncement"
            :loading="loading"
          >
            <template v-slot:item="props">
              <tr>
                <td>
                  <a
                    style="color:black"
                    @click="loadAnnouncement(props.item.id)"
                  >
                    <span
                      :class="{ 
                        'font-weight-bold': (props.item.announcement_employees[0].is_read ===0),
                      }"
                    >
                      {{ props.item.title }}
                    </span>
                  </a>
                </td>

                <td class="text-center">
                  {{ props.item.announcement_date }}
                </td>

                <td class="text-center">
                  {{ props.item.created_by }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="viewAnnouncement">
      <v-col cols="12">
        <v-breadcrumbs
          :items="navItems" 
          divider="/"
          class="py-0"
        >
          <template v-slot:item="props">
            <a
              v-if="!props.item.disabled"
              @click="updatePage"
            >{{ props.item.text }}</a>
            <span v-else>{{ announcement && announcement.title ? announcement.title : '' }}</span>
          </template>
        </v-breadcrumbs>
      </v-col>

      <v-col cols="12">
        <v-card class="elevation-10">
          <v-row>
            <v-col cols="12">
              <span class="font-weight-bold pl-4 mt-4">{{ (announcement||{}).title }}</span>
            </v-col>
            
            <v-col
              cols="12"
              class="py-1 pl-7 mt-n4"
            >
              <i v-html="formatContent(announcement.description)" />
            </v-col>

            <v-col
              v-if="announcement.acknowledgement_required"
              cols="12"
              class="pb-0"
            >
              <span class="font-weight-bold pl-4 mt-4">Acknowledgement</span>
            </v-col>
            <v-col
              v-if="announcement.acknowledgement_required"
              cols="12"
              class="py-0 pl-7 mt-n4"
            >
              <v-checkbox
                v-model="acknowledgementSelection"
                :disabled="announcement.announcement_employees.length > 0 && announcement.announcement_employees[0].is_read == 1"
                label="I have read and understand the statements."
              />
            </v-col>
            <v-col
              v-if="announcement.acknowledgement_required && acknowledgementSelection && !announcement.announcement_employees[0].is_read"
              cols="12"
              class="pt-0 pl-7"
            >
              <v-btn
                color="success"
                :loading="agreeLoading"
                @click="acknowledgementAgreed(announcement.id)"
              >
                I Agree
              </v-btn>
            </v-col>
            
            <v-col
              cols="12"
              class="pl-7"
            >
              <span class="font-weight-bold"> Attachments:</span>
            </v-col>

            <v-col
              v-if="((announcement||{}).documents||{}).length >0"
              cols="12"
              class="pl-7 py-0"
            >
              <v-row
                v-for="document in announcement.documents"
                :key="document.id"
                no-gutters
              >
                <v-col cols="12">
                  <v-icon color="red">
                    mdi-file-pdf
                  </v-icon>
                  <v-btn
                    text
                    @click="loadAttachment(document)"
                  >
                    {{ document.file_name }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-show="viewAttachment">
                <v-col>
                  <div>
                    <span class="font-weight-bold">{{ filename ? filename.toUpperCase() : '' }}</span>
                    <v-btn
                      :loading="pdf?false:true"
                      icon
                      color="primary"
                      @click="resetViewAttachment()"
                    >
                      <v-icon
                        size="20"
                        color="red"
                      >
                        mdi-close
                      </v-icon>
                    </v-btn>
                    <vue-pdf-app
                      v-if="filename"
                      style="height: 75vh;"
                      :pdf="pdf"
                      :config="config"
                      @open="openHandler"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              v-else
              cols="12"
              class="pl-7 py-0"
            >
              <span>N/A</span>
            </v-col>

            <v-col
              cols="12"
              class="pl-7"
            >
              <span class="font-weight-bold"> Videos:</span>
            </v-col>
            
            <v-col
              v-if="((announcement||{}).links ||{}).length >0"
              cols="12"
              class="pl-7 py-0"
            >
              <v-row>
                <v-col
                  v-for="link in announcement.links"
                  :key="link.id"
                  cols="4"
                >
                  <v-skeleton-loader
                    v-show="!(iframe.loaded)"
                    type="image"
                  />

                  <iframe
                    v-show="iframe.loaded"
                    ref="frame"
                    :src="link.file_link"
                    width="470"
                    height="295"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    @load="load"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col
              v-else
              cols="12"
              class="pl-7 pt-0"
            >
              <span>N/A</span>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import 'vue-pdf-app/dist/icons/main.css'
  import VuePdfApp from 'vue-pdf-app'

  export default {
    components: {
      VuePdfApp,
    },
    data () {
      return {
        acknowledgementSelection: false,
        agreeLoading: false, 
        pdf: '',
        filename: '',
        viewAttachment: false,
        config: {
          // toolbar: false,
          toolbar: {
            // toolbarViewerLeft: { findbar: false },
            toolbarViewerRight: { print: false, download: false, openFile: false, viewBookmark: false },
          },
        },

        search: '',
        loading: false,
        viewAnnouncement: false,
        announcements: [],
        announcement: null,
        headers: [
          {
            text: 'Announcement Title',
            align: 'left',
            value: 'title',
          },
          {
            text: 'Announcement Date',
            align: 'center',
            value: 'announcement_date',
          }, 
          {
            text: 'Announcement By',
            align: 'center',
            value: 'created_by',
          },         
        ],
        navItems: [
          {
            text: 'E-Notice Board',
            disabled: false,
          },
          {
            text: 'Announcement',
            disabled: true,
          },
        ],
        iframe: {
          loaded: false,
        },
        announcementCategories: [],
        announcementCategoryFilter: '',
      } 
    },
    computed: {
      filterAnnouncement () {
        return this.announcements.filter(annoucement => {
          if (!this.announcementCategoryFilter) return annoucement
          return annoucement.announcement_category_id === this.announcementCategoryFilter
        })
      },
    },
    created () {
      if (this.$route.params.id) {
        this.loadAnnouncement(this.$route.params.id)
      } else {
        this.loadEmployeeAnnouncements()
      }
      this.loadAnnouncementCategories()
    },

    methods: {
      load () {
        this.iframe.loaded = true
      },
      resetViewAttachment () {
        this.viewAttachment = false
        this.pdf = null
        this.filename = null
      },
      loadAttachment (attachment) {
        this.resetViewAttachment()
        this.viewAttachment = true

        this.$api.announcementDocuments().show(attachment.id)
          .then(res => {
            let blob = new Blob([res.data], { type: 'application/pdf' })
            this.pdf = window.URL.createObjectURL(blob)
            this.filename = attachment.file_name
          })
      },
      loadAnnouncementCategories () {
        this.$api.announcementCategories().list()
          .then(response => {
            this.announcementCategories = response.data
          })
      },
      openHandler (pdfApp) {
        this.prohibit()
      },
      prohibit () {
        // disable print
        window.print = function emptyMethod () {}

        // disable right-click
        document.oncontextmenu = function () {
          return false
        }
        document.onkeydown = function (e) {
          // disable Ctrl button
          if (e.ctrlKey) {
            // alert('"Ctrl" key is not allowed for this page.')
            e.cancelBubble = true
            e.preventDefault()

            e.stopImmediatePropagation()
            
            return false
          }

          // disable F12 button
          if (e.keyCode === 123) {
            // alert('"F12" key is not allowed for this page.')
            return false
          }
        }
      },
      loadEmployeeAnnouncements () {
        this.loading = true

        this.$api.employeeAnnouncements().list('true')
          .then(res => {
            res.data.map(announcement => {
              announcement.announcement_employees.map(item => {
                // if (item.is_read) {
                //   announcement.is_read = item.is_read
                // } else {
                //   announcement.is_read = item.is_read
                // }
                announcement.is_read = item.is_read
              })
            })

            this.announcements = _.orderBy(res.data, ['is_read', 'created_at'], ['asc', 'desc'])  

            this.loading = false
            this.viewAnnouncement = false
          })
      },

      formatContent (content) {
        if (content.includes('https') || content.includes('http')) {
          let urlRegex = /(https?:\/\/[^\s]+)/g
          return content.replace(urlRegex, function (url) {
            return '<br><a href="' + url + '" target="_blank">' + url + '</a>'
          })  
        }
     
        return content
      },

      loadAnnouncement (id) {
        this.iframe.loaded = false

        this.$api.announcements().show(id)
          .then(res => {
            this.announcement = res.data

            if (this.announcement && !this.announcement.acknowledgement_required) {
              this.$api.employeeAnnouncements().markAsRead(id)
            }
            if (this.announcement && this.announcement.acknowledgement_required) {
              this.acknowledgementSelection = this.announcement.announcement_employees[0].is_read
            }
            
            this.viewAnnouncement = true
          })
      },

      updatePage () {
        this.resetViewAttachment()
        this.loadEmployeeAnnouncements()
      },

      acknowledgementAgreed (id) {
        this.agreeLoading = true
        this.$api.employeeAnnouncements().markAsRead(id)
          .then(res => {
            this.loadAnnouncement(id)
          })
        this.agreeLoading = false
      },
    },
  }
</script>
